var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bonus-leader-share"},[_c('p',{staticClass:"bonus-leader-share__title"},[_vm._v("Квалификации")]),_c('ul',{staticClass:"bonus-leader-share__tariffs"},_vm._l((_vm.qualifications),function(qualification,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(_vm.formatQualification(qualification))+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }